export function parseSRT(srtText) {
    const blocks = srtText
      .split(/\r?\n\r?\n/)
      .map((block) => {
        const lines = block.trim().split("\n");
        if (lines.length < 2) return null;
  
        // Format: 00:00:10,000 --> 00:00:12,000
        const [startTime, endTime] = lines[1].split(" --> ").map(parseTime);
  
        const text = lines.slice(2).join("\n");
        return { start: startTime, end: endTime, text };
      })
      .filter(Boolean);
  
    return blocks;
  }
  
  function parseTime(timeStr) {
    const [hms, ms] = timeStr.split(",");
    const [hours, minutes, seconds] = hms.split(":").map(Number);
    return (
      hours * 3600 * 1000 +
      minutes * 60 * 1000 +
      seconds * 1000 +
      parseInt(ms, 10)
    );
  }
  